import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { useAnimation } from 'framer-motion';

import { ChipMember } from '@pkg/components';
import { useBreakpoints } from '@pkg/hooks';

import { useRecentYatsQuery } from './useRecentYatsQuery';

import { Label, Marquee, Track, Wrapper } from './RecentYats.style';

export function RecentYats() {
    const controls = useAnimation();
    const containerRef = useRef<HTMLDivElement | null>(null);
    const { isMobile } = useBreakpoints();
    const { data: emojis, isLoading } = useRecentYatsQuery();

    const length = useMemo(() => emojis?.length || 0, [emojis]);

    const handleStart = useCallback(() => {
        const containerWidth = containerRef.current?.offsetWidth || length * 400 || 0;
        const speed = 100;
        const duration = containerWidth / speed;
        controls.start({
            x: '-50%',
            transition: { duration, ease: 'linear', repeat: Infinity, repeatType: 'reverse' },
        });
    }, [controls, length]);

    useEffect(() => {
        handleStart();
        return controls.stop;
    }, [length, isLoading, handleStart, controls.stop]);

    const chipsMarkup = emojis?.length
        ? [...emojis, ...emojis, ...emojis].map((emoji, i) => (
              <ChipMember key={emoji + i} yat={emoji} size={isMobile ? 'medium' : 'large'} />
          ))
        : null;

    return (
        <Wrapper>
            <Label>Recently Created Yats</Label>

            <Marquee>
                <Track ref={containerRef} animate={controls}>
                    {isLoading ? null : chipsMarkup}
                </Track>
            </Marquee>
        </Wrapper>
    );
}
